import React, { useState, useEffect } from 'react'
import { Container } from 'react-bootstrap'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { graphql, useStaticQuery } from 'gatsby'

import LogoLink from './components/LogoLink'
import HeaderActionLinks from './components/HeaderActionLinks'
import HeaderMobileNav from './components/HeaderMobileNav'

import * as s from './Header.module.scss'

const NAV_BAR_QUERY = graphql`
  query {
    navbarJson {
      actionButtonPrimaryText
      actionButtonSecondaryText
      actionButtonPrimaryLink {
        text
        title
        to
      }
      actionButtonSecondaryLink {
        text
        title
        to
      }
    }
  }
`

const Header = (props) => {
  const { slug, siteTitle, isLP, menu, className, ...rest } = props
  const { navbarJson } = useStaticQuery(NAV_BAR_QUERY)

  const {
    actionButtonPrimaryText: primaryText,
    actionButtonPrimaryLink: primaryLink,
    actionButtonSecondaryText: secondaryText,
    actionButtonSecondaryLink: secondaryLink,
  } = navbarJson

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isLoaded, setIsLoaded] = useState(false)

  const navLinks = [
    { id: 'app', text: 'The App', to: '/app' },
    { id: 'token', text: 'The Token', to: '/token' },
    { id: 'ecosystem', text: 'The Ecosystem', to: '/ecosystem' },
  ]

  useEffect(() => {
    const loaded = localStorage.getItem('isLoaded')
    if (!loaded) {
      localStorage.setItem('isLoaded', 'true')
    }
    setIsLoaded(!!loaded)
  }, [])

  const animationProps = !isLoaded
    ? {
        'data-sal': 'slide-down',
        'data-sal-delay': '1000',
        'data-sal-easing': 'ease-out-back',
        'data-sal-duration': '2000',
      }
    : {}

  return (
    <header
      {...rest}
      {...animationProps}
      className={cn(
        s.header,
        { [s.fixed]: isLP },
        { [s.bg]: isLP && !isModalOpen },
        className
      )}
    >
      <Container as="nav" className={s.headerInner}>
        <LogoLink siteTitle={siteTitle} />

        <ul className="gap-4 cursor-pointer hidden lg:flex">
          {navLinks.map((link) => (
            <li key={link.id}>
              <a
                href={link.to}
                className={cn('text-primary font-medium hover:font-semibold', {
                  'custom-nav font-semibold': slug === link.to,
                })}
              >
                {link.text}
              </a>
            </li>
          ))}
        </ul>

        <HeaderActionLinks
          primaryText={primaryText}
          secondaryText={secondaryText}
          primaryLink={primaryLink}
          secondaryLink={secondaryLink}
          className={s.headerActionLink}
        />
        <HeaderMobileNav
          isLP={isLP}
          navMenu={navLinks}
          primaryText={primaryText}
          primaryLink={primaryLink}
          secondaryText={secondaryText}
          secondaryLink={secondaryLink}
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          className={s.headerMobileNav}
        />
      </Container>
    </header>
  )
}

Header.defaultProps = {
  className: undefined,
  siteTitle: '',
  isLP: false,
  menu: undefined,
  slug: '',
}

Header.propTypes = {
  slug: PropTypes.string,
  siteTitle: PropTypes.string,
  isLP: PropTypes.bool,
  className: PropTypes.string,
  menu: PropTypes.arrayOf(PropTypes.object),
}

export default Header
